import axios from 'axios';

const attributeService = {
 
  fetchAttribute: async (userId, token) => {
    try {
      const response = await axios.get('/Attribute', {
        params: {
          isGroupName:true,
          UserId: userId,
        },
        headers:{
          Authorization: `Bearer ${token}`
        }
      });
      return response?.data;
    } catch (error) {
      console.error('Error fetching invoices:', error);
      throw error;
    }
  },
 
}
export default attributeService;
